import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {WordpressService} from "../../../services/wordpress.service";
import {WP_REST_API_Breadcrumb_item} from "../../../models/Wordpress/WP_REST_API_Breadcrumb_item";
import {RouterLink} from "@angular/router";
import {StripTagsPipe} from "../../../pipes/striptags.pipe";

@Component({
  selector: 'breacrumbs',
  standalone: true,
  imports: [CommonModule, RouterLink, StripTagsPipe],
  templateUrl: './breacrumbs.component.html',
  styleUrl: './breacrumbs.component.scss',
  host: {ngSkipHydration: 'true'}
})
export class BreacrumbsComponent implements OnChanges{
  public breadcrumbs:  WP_REST_API_Breadcrumb_item[];
  @Input() postId? : number;
  @Input() hasBackButton : boolean;
  @Input() title? : string;
  constructor(public wp : WordpressService) {

  }

  async ngOnChanges() {
    if(this.postId){
      this.breadcrumbs = await this.wp.getBreadcrumbs(this.postId);
    }
  }
  onClickBack(){
    window.history.back();
  }
  
}
